module.exports = __webpack_public_path__ + "img/1.6d3b82c1.png";